import React, { useEffect, Fragment, useState } from "react";
import { Progress } from "antd";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import ImageOrVideo from "../../../../shared/components/ImageOrVideo/Index";
import TeamLogo from "../../_partials/TeamLogo";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import i18n from "../../../../../language";
import { PresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";
import { getScaleSize } from "../Lineup/Index";
import { ratioFromFormat } from "../ResultsNew/Index";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { getImageFilterStyle, getWrapperDimensions } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";
import MatchStatsBar from "./statsBar";

const getMainBackground = () => {
  return _.get(assets, `mainbackground`);
};

const getBlueBg = () => {
  return assets.bg_blue;
};

export const getOneLetterResult = (data, side, selectedLang) => {
  const { t } = useTranslation();
  if (data?.scoreHome > data?.scoreAway) {
    if (side === "home") {
      return t("W", { keyPrefix: "table", lng: selectedLang });
    } else {
      return t("L", { keyPrefix: "table", lng: selectedLang });
    }
  }

  if (data?.scoreHome < data?.scoreAway) {
    if (side === "home") {
      return t("L", { keyPrefix: "table", lng: selectedLang });
    } else {
      return t("W", { keyPrefix: "table", lng: selectedLang });
    }
  }

  if (data?.scoreHome === data?.scoreAway) {
    return t("D", { keyPrefix: "table", lng: selectedLang });
  }

  return "-";
};

const Index = ({ animation, data, mode, format, prevRatio, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const backgroundImage = getMainBackground();
  const blueBg = getBlueBg();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { options, fields, dynamic, editData } = data.data || {};

  const {
    totalScores,
    homeTeamScorers,
    awayTeamScorers,
  } = data?.data?.dynamic;

  const homeTeam = data?.event?.home;
  const awayTeam = data?.event?.away;
  let statsLeftTeam = homeTeam;
  let statsRightTeam = awayTeam;
  if (statsRightTeam.shortcut == 'FCB') {
    statsLeftTeam = awayTeam;
    statsRightTeam = homeTeam;
  }

  const competitionId = data?.event?.competitionId;

  const date = data?.event?.date;
  const time = data?.event?.time;
  const [day, month, year] = date.split(".");
  const dateTimeString = `${year}-${month}-${day}T${time}`;
  const basetime = new Date(dateTimeString);
  const quoteText = getContentById("quote", fields);
  const author = getContentById("author", fields);
  const customBackground = getContentById("background", fields, "self");
  const homeWins = totalScores?.homeWins || 0;
  const homeDraws = totalScores?.homeDraws || 0;
  const homeLoss = totalScores?.homeLoss || 0;
  const manualEntries = editData?.manualEntries;
  let numberOfWins = homeWins
  let numberOfDraws = homeDraws
  let numberOfLosses = homeLoss;
  if (isNaN(numberOfWins)) {
    numberOfWins = 0;
  }
  if (isNaN(numberOfDraws)) {
    numberOfDraws = 0;
  }
  if (isNaN(numberOfLosses)) {
    numberOfLosses = 0;
  }

  if (!!manualEntries) {
    const { win, draw, loss } = manualEntries;

    const valid =
      [win, draw, loss].some(v => v !== 0) &&    // at least one is not zero
      [win, draw, loss].every(v => !isNaN(v));   // none are NaN

    if (valid) {
      // safe to use manualEntries
      numberOfWins = manualEntries.win;
      numberOfDraws = manualEntries.draw;
      numberOfLosses = manualEntries.loss;
    }
  }

  const numberOfMatches = Math.max(numberOfWins, 0.5) + Math.max(numberOfDraws, 0.5) + Math.max(numberOfLosses, 0.5);
  const { t } = useTranslation();
  const selectedLang = data?.lang;
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    jersey: PresetColors.white,
  }
  const [effects, setEffects] = useState(defaultEffects);


  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? defaultEffects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else {
      const editData = data?.data?.editData;
      if (editData) {
        setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
      } else {
        setRatioSize(getScaleSize(format, 0));
      }
    }
  }, [format, prevRatio])

  const mapValue = (val, inMin = 8, inMax = 76, outMin = 52, outMax = 92) => {
    const mapped =
      ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;

    // clamp between outMin and outMax
    return Math.min(Math.max(mapped, outMin), outMax);
  };

  const totalWidthInPixel = 823;
  const winWidth = (Math.max(numberOfWins, 0.5) / numberOfMatches) * totalWidthInPixel;
  const drawWidth = ((Math.max(numberOfDraws, 0.5)) / numberOfMatches) * totalWidthInPixel;
  const lossWidth = (Math.max(numberOfLosses, 0.5) / numberOfMatches) * totalWidthInPixel;
  const drawFakePolygon = (100 - mapValue((Math.max(numberOfWins, 0.5) / numberOfMatches) * 100)) / 100;
  const drawFakeBarWidth = winWidth * drawFakePolygon;
  const cutWidthPixel = 20;

  const mapValuePixel = (_width) => {
    return _width - cutWidthPixel;
  }
  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""}`}
    >
      <TemplateBlock>
        <div className={"custom-background-container"}>
          <div
            id={_.get(customBackground, "id", null)}
            style={customBackgroundStyles}
            className={"custom-background"}
          >
            {layers
              .map((layer, index) => {
                const { id, adjustments, imageUrl, dimensions, x, y } = layer;
                const filterStyles = getImageFilterStyle(adjustments);
                const { colorOverlays = [], ...filterStyle } = filterStyles;
                return (
                  <div
                    style={{
                      position: 'absolute',
                      width: `${dimensions.width * ratioSize.width}px`,
                      height: `${dimensions.height * ratioSize.height}px`,
                      left: `${x * ratioSize.width}px`,
                      top: `${y * ratioSize.height}px`,
                      ...filterStyle
                    }}
                    key={id}
                  >
                    <img
                      src={imageUrl}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: "65%", // Adjust as needed
                        background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(20, 20, 20, 0.7) 40%, rgba(30,30,30,1) 100%)",
                        pointerEvents: "none",
                        zIndex: 2,
                      }}
                    />
                    {/* Color overlays */}
                    {colorOverlays.map((overlayStyle, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          ...overlayStyle
                        }}
                      />
                    ))}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="gradient-full"></div>
        <div class="match-stats-container-wrap">
          <div class="match-stats-container">
            <div
              class="progress-segment wins"
              style={{
                width: `${winWidth}px`,
              }}
            >
              <div className={`logo`}>
                <TeamLogo team={homeTeam} competitionId={competitionId} />
              </div>
              <div className="bar"
                style={{
                  clipPath: `polygon(0 0, ${mapValuePixel(winWidth)}px 0, 100% 30%, 100% 100%, ${cutWidthPixel}px 100%, 0 70%)`
                }}>
              </div>
              <div class="label">
                {t("W", { keyPrefix: "table", lng: selectedLang })}
              </div>
              <div class="value">{numberOfWins}</div>
              <div class="label-full">{t("Wins", { keyPrefix: "table", lng: selectedLang })}</div>
            </div>
            <div
              class="progress-segment draws"
              style={{
                width: `${drawWidth}px`
              }}
            >
              <div
                className="bar"
                style={{
                  clipPath: `polygon(0 0, ${mapValuePixel(drawWidth)}px 0, 100% 30%, 100% 100%, 0 100%)`
                }}
              >
              </div>
              <div className="bar-fake"
                style={{
                  width: `${drawFakeBarWidth}px`,
                  left: `calc(${-drawFakeBarWidth + 2}px)`
                }}>
              </div>
              <div class="label">{t("D", { keyPrefix: "table", lng: selectedLang })}</div>
              <div class="value">{numberOfDraws}</div>
              <div class="label-full">{t("Draws", { keyPrefix: "table", lng: selectedLang })}</div>
            </div>
            <div
              class="progress-segment losses"
              style={{
                width: `${lossWidth}px`
              }}
            >
              <div className={`logo`}>
                <TeamLogo team={awayTeam} competitionId={competitionId} />
              </div>
              <div
                className="bar"
                style={{
                  clipPath: `polygon(0 0, ${mapValuePixel(lossWidth)}px 0, 100% 30%, 100% 100%, 0 100%)`
                }}>
              </div>
              <div
                className="bar-fake"
                style={{
                  width: `calc(${drawWidth * mapValue((Math.max(numberOfDraws, 0.5) / numberOfMatches)) / 100 + 2}px)`,
                  left: `calc(${- drawWidth * mapValue((Math.max(numberOfDraws, 0.5) / numberOfMatches)) / 100}px)`
                }}>
              </div>
              <div class="label">{t("L", { keyPrefix: "table", lng: selectedLang })}</div>
              <div class="value">{numberOfLosses}</div>
              <div class="label-full">{t("Losses", { keyPrefix: "table", lng: selectedLang })}</div>
            </div>
          </div>
        </div>
        <div className="goal-player-container">
          <div className="goal-player-home">
            {/* home team logo */}
            <div className="home-team-logo-container">
              <TeamLogo team={homeTeam} competitionId={competitionId} />
            </div>
            {/* home team top scorers */}
            <div className="home-team-table">
              <div className="home-team-table-head">
                <div className="content"></div>
                <div className="goals text-label">
                  {t("Goals", { keyPrefix: "table", lng: selectedLang })}
                </div>
                <div className="assists text-label">
                  {t("Assits", { keyPrefix: "table", lng: selectedLang })}
                </div>
              </div>
              {
                homeTeamScorers?.map((entry, index) => {
                  return (
                    <div className="home-team-table-row">
                      <div className="player-name">
                        {entry.player.name}
                      </div>
                      <div className="goals text-value">
                        {entry.goals}
                      </div>
                      <div className="assists text-value">
                        {entry.assists}
                      </div>
                    </div>
                  )
                })
              }

            </div>
          </div>

          <div className="goal-player-away">
            {/* home team logo */}
            <div className="home-team-logo-container">
              <TeamLogo team={awayTeam} competitionId={competitionId} />
            </div>
            {/* home team top scorers */}
            <div className="home-team-table">
              <div className="home-team-table-head">
                <div className="content"></div>
                <div className="goals text-label">
                  {t("Goals", { keyPrefix: "table", lng: selectedLang })}
                </div>
                <div className="assists text-label">
                  {t("Assits", { keyPrefix: "table", lng: selectedLang })}
                </div>
              </div>
              {
                awayTeamScorers?.map((entry, index) => {
                  return (
                    <div className="home-team-table-row">
                      <div className="player-name">
                        {entry.player.name}
                      </div>
                      <div className="goals text-value">
                        {entry.goals}
                      </div>
                      <div className="assists text-value">
                        {entry.assists}
                      </div>
                    </div>
                  )
                })
              }

            </div>
          </div>
        </div>

        <div className="custom-quote-container">
          <div className="quote-shape-wrapper">
            <div className="quote-shape-box"></div>
            <div className="quote-shape-box"></div>
          </div>
          <div className="quote-text">
            {quoteText}
          </div>
        </div>
        <div className="quote-bottom">
          <div className="quote-line"></div>
          <div className="quote-author">- {author} -</div>
        </div>

      </TemplateBlock>
    </div>
  );
};

export default Index;
